import { getIsAppNewVersion } from "_helpers";
import {
  NewVersionInfoModalContent,
  NewVersionInfoModalFooter,
} from "_lib/Common";
import { Modal } from "antd";
import { useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useNewVersion = () => {
  const { pathname } = useLocation();
  const [modal, contextHolder] = Modal.useModal();

  const onVersionChange = useCallback(async () => {
    const isAppNewVersion = await getIsAppNewVersion();
    if (!isAppNewVersion) return;
    modal.info({
      width: 320,
      icon: null,
      content: <NewVersionInfoModalContent />,
      footer: <NewVersionInfoModalFooter />,
    });
  }, [modal]);

  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;
    onVersionChange();
  }, [onVersionChange, pathname]);
  return {
    newVersionContextHolder: contextHolder,
  };
};
